import type { ReactElement, ReactNode } from 'react';
import { globalStore } from '@/GlobalStore';
import type { UserInfoDTO } from '@/global/GlobalType';
import type { Team } from '@/common/model';

type Props = typeof globalStore & {
  init: () => Promise<void>;
  login: (payload: { phone: string; code: string }) => Promise<{ token: string; userDTO: UserInfoDTO } | null>;
  changeTeam: (teamId: string) => void;
  updateUserInfo: (payload: {
    id: string;
    userAvatar: string;
    realName: string;
    nickname: string;
    brief: string;
  }) => Promise<boolean>;
  getUserInfo: (userId: string) => Promise<UserInfoDTO | null>;
  getVerificationCode: (payload: { phone: string; captchaToken?: string }) => Promise<boolean>;
  userInfo: UserInfoDTO | null;
  teamId: string;
  currentTeam: Team | undefined;
  enableLoad: boolean;
};

const store = globalStore as Props;

export default {
  useContainer: (): Props => store,
  Provider: ({ children }: { children?: ReactNode }) => children as ReactElement,
};
